// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1OT0Y","requiredAsterisk":"Info_requiredAsterisk__B1yjw"};